import type { ReactNode } from 'react'

interface AuthCardProps {
  title: string
  subtitle?: ReactNode
  children: ReactNode
  footer?: ReactNode
}

/**
 * Centered card layout shared by sign-in, sign-up, verify-email. Uses the
 * same glass / border treatment as the homepage's floating chrome so the
 * auth surface visually belongs to the same product.
 */
export function AuthCard({ title, subtitle, children, footer }: AuthCardProps) {
  return (
    <div className="mx-auto w-full max-w-md px-4 py-16 sm:py-24">
      <div
        className={[
          'rounded-[var(--radius-lg)]',
          'border border-[var(--color-border)]',
          'bg-[var(--color-elev)]',
          'p-7 sm:p-8',
          'shadow-[var(--shadow-results)]',
        ].join(' ')}
      >
        <h1 className="text-[22px] font-semibold tracking-tight text-[var(--color-text-strong)] m-0">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-2 text-[14px] leading-relaxed text-[var(--color-muted)]">
            {subtitle}
          </p>
        ) : null}
        <div className="mt-6">{children}</div>
      </div>
      {footer ? (
        <p className="mt-5 text-center text-[13px] text-[var(--color-muted)]">
          {footer}
        </p>
      ) : null}
    </div>
  )
}
